import React from 'react';
import { Shield, AlertTriangle, CheckCircle2, Info, FileText, Activity, Layers, AlertCircle, TrendingUp, XCircle, Lock, Eye, Database, UserCheck } from 'lucide-react';
import { AppBadge } from '../components/base/AppBadge';
const MONITORED_SYSTEMS = [{
  id: 's1',
  name: 'Customer Assistant',
  type: 'Chatbot',
  risk: 'Limited',
  status: 'Compliant',
  lastAudit: '12 Ott 2023'
}, {
  id: 's2',
  name: 'Resume Screener',
  type: 'HR Tool',
  risk: 'High',
  status: 'Action Required',
  lastAudit: '05 Ott 2023'
}, {
  id: 's3',
  name: 'Spam Filter',
  type: 'Classifier',
  risk: 'Minimal',
  status: 'Compliant',
  lastAudit: '28 Set 2023'
}, {
  id: 's4',
  name: 'Credit Scoring',
  type: 'Finance',
  risk: 'High',
  status: 'Compliant',
  lastAudit: '10 Ott 2023'
}, {
  id: 's5',
  name: 'Deepfake Generator',
  type: 'Media',
  risk: 'Unacceptable',
  status: 'Blocked',
  lastAudit: '01 Ott 2023'
}];
const REQUIREMENTS = [{
  id: 'req1',
  title: 'Data Governance',
  desc: 'Qualità dei dati di addestramento e mitigazione dei bias.',
  status: 'compliant',
  icon: Database
}, {
  id: 'req2',
  title: 'Transparency',
  desc: 'Tracciabilità e documentazione tecnica aggiornata.',
  status: 'compliant',
  icon: Eye
}, {
  id: 'req3',
  title: 'Human Oversight',
  desc: 'Supervisione umana e possibilità di intervento.',
  status: 'warning',
  icon: UserCheck
}, {
  id: 'req4',
  title: 'Cybersecurity',
  desc: 'Robustezza, accuratezza e sicurezza informatica.',
  status: 'compliant',
  icon: Lock
}];
export function AIActPage() {
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-1354" data-mp="3hxahidzi1vup">
      {/* Header Section */}
      <div className="mb-8" data-id="element-1355" data-mp="2u7g5tzqx2dc1">
        <h1 className="text-[28px] md:text-[32px] font-semibold text-[#2a3a54] tracking-tight" data-id="element-1356" data-mp="2u6mvkosr15p5">
          AI Act Compliance
        </h1>
      </div>

      {/* Top Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-1357" data-mp="t68i83hgkvw1">
        {/* Stat 1 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1358" data-mp="y4jrabzxj2d7">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1359" data-mp="12xw3tnrc3ipl">
            Compliance Score
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1360" data-mp="17uwbg33u0tit">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1361" data-mp="a8p8exn6f98k">98%</span>
            <span className="text-[13px] text-emerald-600 font-medium flex items-center gap-1" data-id="element-1362" data-mp="f6qp5bx4qwgv">
              <TrendingUp className="w-3.5 h-3.5" data-id="element-1363" data-mp="k6d2dlcykcpo" /> +2%
            </span>
          </div>
        </div>

        {/* Stat 2 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1364" data-mp="p5g692h7ccw2">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1365" data-mp="1vm1oybmav9py">
            Sistemi Monitorati
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1366" data-mp="20j0h4omel6li">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1367" data-mp="3l248lmmi9u7g">12</span>
            <span className="text-[13px] text-gray-500 font-medium" data-id="element-1368" data-mp="3l46y85jqxlbn">
              Attivi
            </span>
          </div>
        </div>

        {/* Stat 3 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1369" data-mp="3bb9mqjd68wmj">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1370" data-mp="36coo2odkil07">
            Sistemi ad Alto Rischio
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1371" data-mp="31fprlz6fm1yu">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1372" data-mp="2xbqg5v00dtcc">2</span>
            <span className="text-[13px] text-amber-600 font-medium flex items-center gap-1" data-id="element-1373" data-mp="2sdgo3t9kz8uy">
              <AlertCircle className="w-3.5 h-3.5" data-id="element-1374" data-mp="2nevl5m2y2b2t" /> 1 richiede azione
            </span>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-8" data-id="element-1375" data-mp="qlka8czxxmx0">
        {/* Modified Header Section */}
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-1376" data-mp="3ffi5fe6zghnt">
          <h2 className="text-[16px] font-semibold text-[#2a3a54]" data-id="element-1377" data-mp="3jgu0hz8mlv3e">
            Sistemi AI Monitorati
          </h2>
          <button className="text-[13px] text-gray-500 font-medium hover:text-[#2a3a54] transition-colors" data-id="element-1378" data-mp="35hkiqv4rusxb">
            Esporta Report
          </button>
        </div>
        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-1379" data-mp="2vqptdhw8bd7n">
          <table className="w-full text-left border-collapse" data-id="element-1380" data-mp="2vp51k01au8dh">
            <thead data-id="element-1381" data-mp="30irezufaegac">
              <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-1382" data-mp="30j96yeux28cg">
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1383" data-mp="2mrm94albsrrk">
                  Sistema
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1384" data-mp="2csdk7w5bi3c2">
                  Tipo
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1385" data-mp="2hq5c4q5yppg9">
                  Livello di Rischio
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1386" data-mp="1u4l77eghq67m">
                  Status
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1387" data-mp="2855sqidsig4t">
                  Ultimo Audit
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-1388" data-mp="2h3r4nuorawwm">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1389" data-mp="2qulvzdgv0mox">
              {MONITORED_SYSTEMS.map(system => <tr key={system.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-1390" data-mp="2lwk9sjo50798">
                  <td className="px-6 py-4" data-id="element-1391" data-mp="30q5m1j8qsr5r">
                    <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-1392" data-mp="2vuhx94y6a00s">
                      {system.name}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1393" data-mp="37vpzwhyhulm7">
                    <span className="text-[13px] text-gray-500" data-id="element-1394" data-mp="37whvhss3cjch">
                      {system.type}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1395" data-mp="3hlj8rb794mmr">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${system.risk === 'Minimal' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : system.risk === 'Limited' ? 'bg-blue-50 text-blue-700 border-blue-100' : system.risk === 'High' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-1396" data-mp="3hmkuc9lw8riq">
                      {system.risk}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1397" data-mp="21946vztxiy24">
                    {system.status === 'Compliant' ? <div className="flex items-center gap-1.5 text-emerald-600" data-id="element-1398" data-mp="266mhrvribncr">
                        <CheckCircle2 className="w-4 h-4" data-id="element-1399" data-mp="1yoel0bfo0j7j" />
                        <span className="text-[13px] font-medium" data-id="element-1400" data-mp="1tvlgnoo3zcvz">
                          Conforme
                        </span>
                      </div> : system.status === 'Action Required' ? <div className="flex items-center gap-1.5 text-amber-600" data-id="element-1401" data-mp="1jz09oxsj3rpi">
                        <AlertTriangle className="w-4 h-4" data-id="element-1402" data-mp="2hm8z33vnhkws" />
                        <span className="text-[13px] font-medium" data-id="element-1403" data-mp="2hjd4npj0hed3">
                          Azione Richiesta
                        </span>
                      </div> : <div className="flex items-center gap-1.5 text-red-600" data-id="element-1404" data-mp="27pmi4q6g3e01">
                        <XCircle className="w-4 h-4" data-id="element-1405" data-mp="22nx3l0k0ki77" />
                        <span className="text-[13px] font-medium" data-id="element-1406" data-mp="w8w7muuzo00m">
                          Bloccato
                        </span>
                      </div>}
                  </td>
                  <td className="px-6 py-4" data-id="element-1407" data-mp="1gww2iw59yu5t">
                    <span className="text-[13px] text-gray-500" data-id="element-1408" data-mp="1gw47pnji50gl">
                      {system.lastAudit}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1409" data-mp="17xirhz1i5xiz">
                    <button className="text-[13px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-1410" data-mp="17ytrrovqon5c">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col divide-y divide-gray-100" data-id="element-1411" data-mp="1qvl93srq0s6r">
          {MONITORED_SYSTEMS.map(system => <div key={system.id} className="p-4 flex flex-col gap-3" data-id="element-1412" data-mp="1uweykqktaf1r">
              <div className="flex justify-between items-start" data-id="element-1413" data-mp="2imsskmmyinyz">
                <div data-id="element-1414" data-mp="2ilhpkp1c5k8x">
                  <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-1415" data-mp="2iky4x0kawhr7">
                    {system.name}
                  </p>
                  <p className="text-[12px] text-gray-500" data-id="element-1416" data-mp="by0ili91zxnt">{system.type}</p>
                </div>
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-medium border ${system.risk === 'Minimal' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : system.risk === 'Limited' ? 'bg-blue-50 text-blue-700 border-blue-100' : system.risk === 'High' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-1417" data-mp="6zz131ra06eg">
                  {system.risk}
                </span>
              </div>
              <div className="flex justify-between items-center mt-1" data-id="element-1418" data-mp="2ydgsvcewpu8">
                <div className="flex items-center gap-1.5" data-id="element-1419" data-mp="2vhkfbg7q97w">
                  {system.status === 'Compliant' ? <span className="text-[12px] font-medium text-emerald-600 flex items-center gap-1" data-id="element-1420" data-mp="1ecr1jrbvcp61">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-1421" data-mp="19e69if6rtbso" /> Conforme
                    </span> : system.status === 'Action Required' ? <span className="text-[12px] font-medium text-amber-600 flex items-center gap-1" data-id="element-1422" data-mp="1g2rteyfskbqr">
                      <AlertTriangle className="w-3.5 h-3.5" data-id="element-1423" data-mp="1b6kzy54l0spp" /> Azione Richiesta
                    </span> : <span className="text-[12px] font-medium text-red-600 flex items-center gap-1" data-id="element-1424" data-mp="11eyezh2fzf9r">
                      <XCircle className="w-3.5 h-3.5" data-id="element-1425" data-mp="wfc43ea36b44" /> Bloccato
                    </span>}
                </div>
                <button className="text-[12px] font-medium text-[#00B4D8]" data-id="element-1426" data-mp="scxhqk77kt83">
                  Dettagli
                </button>
              </div>
            </div>)}
        </div>
      </div>

      {/* Main Grid */}
    </div>;
}